/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import './common';
import '../../../connect/v2/common/money';
import './geographic';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "fulfillment": {
        "nested": {
          "behaviors": {
            "nested": {
              "common": {
                "nested": {
                  "Fee": {
                    "fields": {
                      "clientFeeIdentifier": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "defaultLabel": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "conditions": {
                        "type": ".squareup.fulfillment.behaviors.common.Fee.Condition",
                        "id": 3,
                        "rule": "repeated"
                      },
                      "calculation": {
                        "type": ".squareup.fulfillment.behaviors.common.Fee.Calculation",
                        "id": 4,
                        "rule": "optional"
                      },
                      "constraints": {
                        "type": ".squareup.fulfillment.behaviors.common.Fee.Constraints",
                        "id": 5,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "Condition": {
                        "fields": {
                          "conditionType": {
                            "type": ".squareup.fulfillment.behaviors.common.Fee.Condition.ConditionType",
                            "id": 1,
                            "rule": "optional"
                          },
                          "cart": {
                            "type": ".squareup.fulfillment.behaviors.common.Fee.Condition.CartCondition",
                            "id": 2
                          }
                        },
                        "nested": {
                          "ConditionType": {
                            "values": {
                              "CONDITION_TYPE_DO_NOT_USE": 0,
                              "CONDITION_TYPE_CART": 1
                            }
                          },
                          "CartCondition": {
                            "fields": {
                              "subtotal": {
                                "type": ".squareup.fulfillment.behaviors.common.MoneyRange",
                                "id": 1,
                                "rule": "optional"
                              }
                            }
                          },
                          "condition": {
                            "oneof": ["cart"]
                          }
                        }
                      },
                      "Calculation": {
                        "fields": {
                          "calculationType": {
                            "type": ".squareup.fulfillment.behaviors.common.Fee.Calculation.CalculationType",
                            "id": 1,
                            "rule": "optional"
                          },
                          "feeAllocationRules": {
                            "type": ".squareup.fulfillment.behaviors.common.Fee.Calculation.FeeAllocations",
                            "id": 5,
                            "rule": "optional"
                          },
                          "flat": {
                            "type": ".squareup.fulfillment.behaviors.common.Fee.Calculation.FlatCalculation",
                            "id": 2
                          },
                          "percent": {
                            "type": ".squareup.fulfillment.behaviors.common.Fee.Calculation.PercentageCalculation",
                            "id": 3
                          },
                          "geoZone": {
                            "type": ".squareup.fulfillment.behaviors.common.Fee.Calculation.GeoZoneCalculation",
                            "id": 4
                          }
                        },
                        "nested": {
                          "CalculationType": {
                            "values": {
                              "CALCULATION_TYPE_DO_NOT_USE": 0,
                              "CALCULATION_TYPE_FLAT": 1,
                              "CALCULATION_TYPE_PERCENTAGE": 2,
                              "CALCULATION_TYPE_GEO_ZONE": 3,
                              "CALCULATION_TYPE_EXTERNAL": 4
                            }
                          },
                          "FlatCalculation": {
                            "fields": {
                              "amount": {
                                "type": ".squareup.connect.v2.common.Money",
                                "id": 1,
                                "rule": "optional"
                              }
                            }
                          },
                          "PercentageCalculation": {
                            "fields": {
                              "basisPoints": {
                                "type": "int64",
                                "id": 1,
                                "rule": "optional"
                              }
                            }
                          },
                          "GeoZoneCalculation": {
                            "fields": {
                              "geoZones": {
                                "type": ".squareup.fulfillment.behaviors.common.Fee.Calculation.GeoZoneCalculation.GeoZoneFee",
                                "id": 1,
                                "rule": "repeated"
                              },
                              "fallbackFlatFee": {
                                "type": ".squareup.fulfillment.behaviors.common.Fee.Calculation.FlatCalculation",
                                "id": 2
                              },
                              "fallbackPercentageFee": {
                                "type": ".squareup.fulfillment.behaviors.common.Fee.Calculation.PercentageCalculation",
                                "id": 3
                              }
                            },
                            "nested": {
                              "GeoZoneFee": {
                                "fields": {
                                  "geoArea": {
                                    "type": ".squareup.fulfillment.behaviors.common.GeographicArea",
                                    "id": 1,
                                    "rule": "optional"
                                  },
                                  "flatFee": {
                                    "type": ".squareup.fulfillment.behaviors.common.Fee.Calculation.FlatCalculation",
                                    "id": 2
                                  },
                                  "percentageFee": {
                                    "type": ".squareup.fulfillment.behaviors.common.Fee.Calculation.PercentageCalculation",
                                    "id": 3
                                  }
                                },
                                "nested": {
                                  "fee_calculation": {
                                    "oneof": ["flatFee", "percentageFee"]
                                  }
                                }
                              },
                              "fallback_calculation": {
                                "oneof": ["fallbackFlatFee", "fallbackPercentageFee"]
                              }
                            }
                          },
                          "FeeAllocations": {
                            "fields": {
                              "conditionalAllocationPolicies": {
                                "type": ".squareup.fulfillment.behaviors.common.Fee.Calculation.FeeAllocations.AllocationPolicy",
                                "id": 1,
                                "rule": "repeated"
                              },
                              "defaultAllocationPolicy": {
                                "type": ".squareup.fulfillment.behaviors.common.Fee.Calculation.FeeAllocations.AllocationPolicy",
                                "id": 2,
                                "rule": "optional"
                              }
                            },
                            "nested": {
                              "AllocationPolicy": {
                                "fields": {
                                  "condition": {
                                    "type": ".squareup.fulfillment.behaviors.common.Fee.Calculation.FeeAllocations.AllocationPolicy.AllocationPolicyCondition",
                                    "id": 1,
                                    "rule": "optional"
                                  },
                                  "allocations": {
                                    "type": ".squareup.fulfillment.behaviors.common.Fee.Calculation.Allocation",
                                    "id": 2,
                                    "rule": "repeated"
                                  },
                                  "remainderPayer": {
                                    "type": ".squareup.fulfillment.behaviors.common.Fee.Calculation.AllocationPayer",
                                    "id": 3,
                                    "rule": "optional"
                                  }
                                },
                                "nested": {
                                  "AllocationPolicyCondition": {
                                    "fields": {
                                      "conditionType": {
                                        "type": ".squareup.fulfillment.behaviors.common.Fee.Calculation.FeeAllocations.AllocationPolicy.AllocationPolicyCondition.ConditionType",
                                        "id": 1,
                                        "rule": "optional"
                                      },
                                      "subtotalThreshold": {
                                        "type": ".squareup.fulfillment.behaviors.common.Fee.Calculation.FeeAllocations.AllocationPolicy.AllocationPolicyCondition.SubtotalThresholdCondition",
                                        "id": 2
                                      }
                                    },
                                    "nested": {
                                      "ConditionType": {
                                        "values": {
                                          "CONDITION_TYPE_DO_NOT_USE": 0,
                                          "CONDITION_TYPE_SUBTOTAL_THRESHOLD": 1
                                        }
                                      },
                                      "SubtotalThresholdCondition": {
                                        "fields": {
                                          "subtotalThreshold": {
                                            "type": ".squareup.connect.v2.common.Money",
                                            "id": 1,
                                            "rule": "optional"
                                          }
                                        }
                                      },
                                      "condition": {
                                        "oneof": ["subtotalThreshold"]
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          },
                          "AllocationPayer": {
                            "fields": {
                              "payerType": {
                                "type": ".squareup.fulfillment.behaviors.common.Fee.Calculation.AllocationPayer.PayerType",
                                "id": 1,
                                "rule": "optional"
                              },
                              "payerId": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                              }
                            },
                            "nested": {
                              "PayerType": {
                                "values": {
                                  "PAYER_TYPE_DO_NOT_USE": 0,
                                  "PAYER_TYPE_MERCHANT": 1,
                                  "PAYER_TYPE_BUYER": 2,
                                  "PAYER_TYPE_EXTERNAL": 3
                                }
                              }
                            }
                          },
                          "Allocation": {
                            "fields": {
                              "payer": {
                                "type": ".squareup.fulfillment.behaviors.common.Fee.Calculation.AllocationPayer",
                                "id": 1,
                                "rule": "optional"
                              },
                              "basisPointsOfWholeFee": {
                                "type": "int64",
                                "id": 2
                              },
                              "basisPointsOfRemainingFee": {
                                "type": "int64",
                                "id": 3
                              },
                              "cappedAmount": {
                                "type": ".squareup.connect.v2.common.Money",
                                "id": 4
                              }
                            },
                            "nested": {
                              "allocation_amount": {
                                "oneof": ["basisPointsOfWholeFee", "basisPointsOfRemainingFee", "cappedAmount"]
                              }
                            }
                          },
                          "calculation": {
                            "oneof": ["flat", "percent", "geoZone"]
                          }
                        }
                      },
                      "Constraints": {
                        "fields": {
                          "amountRange": {
                            "type": ".squareup.fulfillment.behaviors.common.MoneyRange",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.fulfillment?.nested?.behaviors?.nested?.common?.nested?.Fee && !$root.nested?.squareup?.nested?.fulfillment?.nested?.behaviors?.nested?.common?.nested?.Fee?.nested?.Condition && !$root.nested?.squareup?.nested?.fulfillment?.nested?.behaviors?.nested?.common?.nested?.Fee?.nested?.Condition?.nested?.ConditionType && !$root.nested?.squareup?.nested?.fulfillment?.nested?.behaviors?.nested?.common?.nested?.Fee?.nested?.Condition?.nested?.CartCondition && !$root.nested?.squareup?.nested?.fulfillment?.nested?.behaviors?.nested?.common?.nested?.Fee?.nested?.Calculation && !$root.nested?.squareup?.nested?.fulfillment?.nested?.behaviors?.nested?.common?.nested?.Fee?.nested?.Calculation?.nested?.CalculationType && !$root.nested?.squareup?.nested?.fulfillment?.nested?.behaviors?.nested?.common?.nested?.Fee?.nested?.Calculation?.nested?.FlatCalculation && !$root.nested?.squareup?.nested?.fulfillment?.nested?.behaviors?.nested?.common?.nested?.Fee?.nested?.Calculation?.nested?.PercentageCalculation && !$root.nested?.squareup?.nested?.fulfillment?.nested?.behaviors?.nested?.common?.nested?.Fee?.nested?.Calculation?.nested?.GeoZoneCalculation && !$root.nested?.squareup?.nested?.fulfillment?.nested?.behaviors?.nested?.common?.nested?.Fee?.nested?.Calculation?.nested?.GeoZoneCalculation?.nested?.GeoZoneFee && !$root.nested?.squareup?.nested?.fulfillment?.nested?.behaviors?.nested?.common?.nested?.Fee?.nested?.Calculation?.nested?.FeeAllocations && !$root.nested?.squareup?.nested?.fulfillment?.nested?.behaviors?.nested?.common?.nested?.Fee?.nested?.Calculation?.nested?.FeeAllocations?.nested?.AllocationPolicy && !$root.nested?.squareup?.nested?.fulfillment?.nested?.behaviors?.nested?.common?.nested?.Fee?.nested?.Calculation?.nested?.FeeAllocations?.nested?.AllocationPolicy?.nested?.AllocationPolicyCondition && !$root.nested?.squareup?.nested?.fulfillment?.nested?.behaviors?.nested?.common?.nested?.Fee?.nested?.Calculation?.nested?.FeeAllocations?.nested?.AllocationPolicy?.nested?.AllocationPolicyCondition?.nested?.ConditionType && !$root.nested?.squareup?.nested?.fulfillment?.nested?.behaviors?.nested?.common?.nested?.Fee?.nested?.Calculation?.nested?.FeeAllocations?.nested?.AllocationPolicy?.nested?.AllocationPolicyCondition?.nested?.SubtotalThresholdCondition && !$root.nested?.squareup?.nested?.fulfillment?.nested?.behaviors?.nested?.common?.nested?.Fee?.nested?.Calculation?.nested?.AllocationPayer && !$root.nested?.squareup?.nested?.fulfillment?.nested?.behaviors?.nested?.common?.nested?.Fee?.nested?.Calculation?.nested?.AllocationPayer?.nested?.PayerType && !$root.nested?.squareup?.nested?.fulfillment?.nested?.behaviors?.nested?.common?.nested?.Fee?.nested?.Calculation?.nested?.Allocation && !$root.nested?.squareup?.nested?.fulfillment?.nested?.behaviors?.nested?.common?.nested?.Fee?.nested?.Constraints) {
  $root.addJSON(jsonData);
}

/**
 * Delivery fee configuration for seller-powered delivery.
 * Fees can have conditions (geographic or cart-based) and various calculation methods.
 *
 * SOURCE Fee @ squareup/fulfillment/behaviors/common/fees.proto at 16:1
 */
export const Fee = $root.lookupType('squareup.fulfillment.behaviors.common.Fee');
fixType(Fee);
Builder.createAndAttachToType(Fee);
/**
 * Conditions that determine when a fee applies.
 * Supports cart constraints (subtotal thresholds).
 *
 * SOURCE Condition @ squareup/fulfillment/behaviors/common/fees.proto at 49:3
 */
Fee.Condition = $root.lookupType('squareup.fulfillment.behaviors.common.Fee.Condition');
fixType(Fee.Condition);
Builder.createAndAttachToType(Fee.Condition);
/**
 * SOURCE ConditionType @ squareup/fulfillment/behaviors/common/fees.proto at 55:5
 */
Fee.Condition.ConditionType = $root.lookupEnum('squareup.fulfillment.behaviors.common.Fee.Condition.ConditionType').values;
/**
 * Cart subtotal-based fee condition.
 * Fee applies when cart subtotal falls within the specified range.
 *
 * SOURCE CartCondition @ squareup/fulfillment/behaviors/common/fees.proto at 65:5
 */
Fee.Condition.CartCondition = $root.lookupType('squareup.fulfillment.behaviors.common.Fee.Condition.CartCondition');
fixType(Fee.Condition.CartCondition);
Builder.createAndAttachToType(Fee.Condition.CartCondition);
/**
 * Defines how to calculate the fee amount.
 * Supports flat fees, percentage-based fees, and geographic zone-based fees.
 *
 * SOURCE Calculation @ squareup/fulfillment/behaviors/common/fees.proto at 75:3
 */
Fee.Calculation = $root.lookupType('squareup.fulfillment.behaviors.common.Fee.Calculation');
fixType(Fee.Calculation);
Builder.createAndAttachToType(Fee.Calculation);
/**
 * SOURCE CalculationType @ squareup/fulfillment/behaviors/common/fees.proto at 88:5
 */
Fee.Calculation.CalculationType = $root.lookupEnum('squareup.fulfillment.behaviors.common.Fee.Calculation.CalculationType').values;
/**
 * Fixed flat fee amount.
 *
 * SOURCE FlatCalculation @ squareup/fulfillment/behaviors/common/fees.proto at 103:5
 */
Fee.Calculation.FlatCalculation = $root.lookupType('squareup.fulfillment.behaviors.common.Fee.Calculation.FlatCalculation');
fixType(Fee.Calculation.FlatCalculation);
Builder.createAndAttachToType(Fee.Calculation.FlatCalculation);
/**
 * Percentage-based fee calculation based on cart subtotal.
 *
 * SOURCE PercentageCalculation @ squareup/fulfillment/behaviors/common/fees.proto at 111:5
 */
Fee.Calculation.PercentageCalculation = $root.lookupType('squareup.fulfillment.behaviors.common.Fee.Calculation.PercentageCalculation');
fixType(Fee.Calculation.PercentageCalculation);
Builder.createAndAttachToType(Fee.Calculation.PercentageCalculation);
/**
 * Geo zone based fee calculation using pricing per zone.
 * Fees are determined by matching the delivery address to a geographic zone.
 *
 * SOURCE GeoZoneCalculation @ squareup/fulfillment/behaviors/common/fees.proto at 120:5
 */
Fee.Calculation.GeoZoneCalculation = $root.lookupType('squareup.fulfillment.behaviors.common.Fee.Calculation.GeoZoneCalculation');
fixType(Fee.Calculation.GeoZoneCalculation);
Builder.createAndAttachToType(Fee.Calculation.GeoZoneCalculation);
/**
 * Fee configuration for a specific geographic zone.
 * Associates a geographic area with its corresponding delivery fee calculation.
 *
 * SOURCE GeoZoneFee @ squareup/fulfillment/behaviors/common/fees.proto at 125:7
 */
Fee.Calculation.GeoZoneCalculation.GeoZoneFee = $root.lookupType('squareup.fulfillment.behaviors.common.Fee.Calculation.GeoZoneCalculation.GeoZoneFee');
fixType(Fee.Calculation.GeoZoneCalculation.GeoZoneFee);
Builder.createAndAttachToType(Fee.Calculation.GeoZoneCalculation.GeoZoneFee);
/**
 * Container for allocation policies that determine how fees are split between parties.
 * Uses a sequential waterfall model where allocations are applied in order,
 * each deducting from the remaining fee amount.
 *
 * Evaluation Process:
 * 1. Evaluate conditional_allocation_policy in order - first matching condition wins
 * 2. If no conditions match, use default_allocation_policy
 * 3. Within the selected policy:
 *    - Process each allocation in order (allocations list)
 *    - Each allocation deducts from the remaining fee
 *    - remainder_payer receives whatever is left
 *
 * Allocation Types:
 * - basis_points_of_whole_fee: % of original total (e.g., 50/50 split)
 * - basis_points_of_remaining_fee: % of what's left after previous allocations
 * - capped_amount: Capped dollar amount (capped at remaining)
 *
 * Example: Total fee $10
 *   default_allocation_policy {
 *     allocations { payer { payer_type: MERCHANT }, capped_amount: $3 }
 *     allocations { payer { payer_type: EXTERNAL, payer_id: "mktp" }, basis_points_of_remaining_fee: 1000 }
 *     remainder_payer { payer_type: BUYER }
 *   }
 *
 * Result:
 *   1. Merchant pays $3 → Remaining: $7
 *   2. External pays 10% of $7 = $0.70 → Remaining: $6.30
 *   3. Buyer pays remainder: $6.30
 *
 * SOURCE FeeAllocations @ squareup/fulfillment/behaviors/common/fees.proto at 186:5
 */
Fee.Calculation.FeeAllocations = $root.lookupType('squareup.fulfillment.behaviors.common.Fee.Calculation.FeeAllocations');
fixType(Fee.Calculation.FeeAllocations);
Builder.createAndAttachToType(Fee.Calculation.FeeAllocations);
/**
 * Defines how a fee should be allocated between parties.
 * Contains optional condition, sequential allocations, and remainder payer.
 *
 * SOURCE AllocationPolicy @ squareup/fulfillment/behaviors/common/fees.proto at 203:7
 */
Fee.Calculation.FeeAllocations.AllocationPolicy = $root.lookupType('squareup.fulfillment.behaviors.common.Fee.Calculation.FeeAllocations.AllocationPolicy');
fixType(Fee.Calculation.FeeAllocations.AllocationPolicy);
Builder.createAndAttachToType(Fee.Calculation.FeeAllocations.AllocationPolicy);
/**
 * Condition that determines when an allocation policy applies.
 * Uses oneof pattern to allow multiple condition types.
 *
 * SOURCE AllocationPolicyCondition @ squareup/fulfillment/behaviors/common/fees.proto at 229:9
 */
Fee.Calculation.FeeAllocations.AllocationPolicy.AllocationPolicyCondition = $root.lookupType('squareup.fulfillment.behaviors.common.Fee.Calculation.FeeAllocations.AllocationPolicy.AllocationPolicyCondition');
fixType(Fee.Calculation.FeeAllocations.AllocationPolicy.AllocationPolicyCondition);
Builder.createAndAttachToType(Fee.Calculation.FeeAllocations.AllocationPolicy.AllocationPolicyCondition);
/**
 * Type of condition.
 * Indicates which condition variant is active in the oneof.
 *
 * SOURCE ConditionType @ squareup/fulfillment/behaviors/common/fees.proto at 234:11
 */
Fee.Calculation.FeeAllocations.AllocationPolicy.AllocationPolicyCondition.ConditionType = $root.lookupEnum('squareup.fulfillment.behaviors.common.Fee.Calculation.FeeAllocations.AllocationPolicy.AllocationPolicyCondition.ConditionType').values;
/**
 * Condition that applies when cart subtotal exceeds a threshold.
 *
 * Example use case: "Free delivery over $25" promotion
 * - subtotal_threshold: $25.00
 *
 * Result: Orders under $25 → use default policy, orders ≥ $25 → use this policy
 *
 * SOURCE SubtotalThresholdCondition @ squareup/fulfillment/behaviors/common/fees.proto at 266:11
 */
Fee.Calculation.FeeAllocations.AllocationPolicy.AllocationPolicyCondition.SubtotalThresholdCondition = $root.lookupType('squareup.fulfillment.behaviors.common.Fee.Calculation.FeeAllocations.AllocationPolicy.AllocationPolicyCondition.SubtotalThresholdCondition');
fixType(Fee.Calculation.FeeAllocations.AllocationPolicy.AllocationPolicyCondition.SubtotalThresholdCondition);
Builder.createAndAttachToType(Fee.Calculation.FeeAllocations.AllocationPolicy.AllocationPolicyCondition.SubtotalThresholdCondition);
/**
 * Identifies a party responsible for paying a portion of a fee.
 * Used in both allocations and remainder specifications.
 *
 * SOURCE AllocationPayer @ squareup/fulfillment/behaviors/common/fees.proto at 282:5
 */
Fee.Calculation.AllocationPayer = $root.lookupType('squareup.fulfillment.behaviors.common.Fee.Calculation.AllocationPayer');
fixType(Fee.Calculation.AllocationPayer);
Builder.createAndAttachToType(Fee.Calculation.AllocationPayer);
/**
 * Type of payer.
 *
 * SOURCE PayerType @ squareup/fulfillment/behaviors/common/fees.proto at 286:7
 */
Fee.Calculation.AllocationPayer.PayerType = $root.lookupEnum('squareup.fulfillment.behaviors.common.Fee.Calculation.AllocationPayer.PayerType').values;
/**
 * Defines a single allocation step in the sequential waterfall model.
 * Each allocation deducts from the remaining fee as allocations are processed in order.
 *
 * Allocation Amount Types:
 * - basis_points_of_whole_fee: % of original total (for simple splits like 50/50)
 * - basis_points_of_remaining_fee: % of what's left (for cascading logic)
 * - capped_amount: Capped dollar amount (capped at remaining)
 *
 * Payer Types:
 * - MERCHANT: The merchant selling the goods
 * - BUYER: The customer purchasing the goods
 * - EXTERNAL: An external party like a marketplace
 *
 * Examples:
 * 1. Simple 50/50 split:
 *    allocations { payer { payer_type: MERCHANT }, basis_points_of_whole_fee: 5000 }
 *    allocations { payer { payer_type: BUYER }, basis_points_of_whole_fee: 5000 }
 *
 *    Total $10: Merchant $5 (50% of $10), Buyer $5 (50% of $10)
 *
 * 2. Merchant pays first $3, marketplace takes 10% of what's left, buyer pays rest:
 *    allocations { payer { payer_type: MERCHANT }, capped_amount: $3 }
 *    allocations { payer { payer_type: EXTERNAL, payer_id: "mktp" }, basis_points_of_remaining_fee: 1000 }
 *    remainder_payer { payer_type: BUYER }
 *
 *    Total $10: Merchant $3, Marketplace $0.70 (10% of $7), Buyer $6.30 (remainder)
 *
 * 3. Merchant pays $2, then merchant pays 30% of what's left, buyer pays rest:
 *    allocations { payer { payer_type: MERCHANT }, capped_amount: $2 }
 *    allocations { payer { payer_type: MERCHANT }, basis_points_of_remaining_fee: 3000 }
 *    remainder_payer { payer_type: BUYER }
 *
 *    Total $10: Merchant $4.40 ($2 + 30% of $8), Buyer $5.60 (remainder)
 *
 * 4. Buyer pays everything:
 *    remainder_payer { payer_type: BUYER }
 *    (no allocations needed)
 *
 * SOURCE Allocation @ squareup/fulfillment/behaviors/common/fees.proto at 347:5
 */
Fee.Calculation.Allocation = $root.lookupType('squareup.fulfillment.behaviors.common.Fee.Calculation.Allocation');
fixType(Fee.Calculation.Allocation);
Builder.createAndAttachToType(Fee.Calculation.Allocation);
/**
 * Constraints applied to the final calculated fee amount.
 *
 * SOURCE Constraints @ squareup/fulfillment/behaviors/common/fees.proto at 410:3
 */
Fee.Constraints = $root.lookupType('squareup.fulfillment.behaviors.common.Fee.Constraints');
fixType(Fee.Constraints);
Builder.createAndAttachToType(Fee.Constraints);